var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchNotFound = function SvgSearchNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 22c0-7.727 6.273-14 14-14s14 6.273 14 14-6.273 14-14 14S8 29.727 8 22ZM22 4C12.064 4 4 12.064 4 22s8.064 18 18 18c4.158 0 7.988-1.412 11.037-3.783l7.773 7.773 3.182-3.182-7.773-7.773A17.918 17.918 0 0 0 40 22c0-9.936-8.064-18-18-18Z",
    fill: "#00121A",
    fillOpacity: 0.57
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m31.707 15.795-3.182-3.182-6.367 6.367-6.365-6.365-3.182 3.182 6.365 6.365-6.36 6.361 3.181 3.182 6.361-6.36 6.363 6.362 3.182-3.182-6.363-6.363 6.367-6.367Z",
    fill: "#00121A",
    fillOpacity: 0.57
  })));
};
export default SvgSearchNotFound;